import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import { SET_PRESSURE_NOTIFICATION, SET_PRESSURE_RECORD } from './actionTypes';
import { PRESSURE_STATES } from './constants';
const DEFAULT_STATE = {
    record: {
        source: 'cpu',
        state: PRESSURE_STATES.NOMINAL,
        time: Date.now()
    },
    wasNotificationShown: false
};
ReducerRegistry.register('wildix/features/pressure-observer', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_PRESSURE_RECORD:
            return {
                ...state,
                record: action.value
            };
        case SET_PRESSURE_NOTIFICATION:
            return {
                ...state,
                wasNotificationShown: action.value
            };
    }
    return state;
});
